(() => {
  const formatMoney = (amount, currency) => {
    const value = Number(amount || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
      }).format(value) + ` ${currency}`;
    } catch (_error) {
      return `${value.toFixed(2)} ${currency}`;
    }
  };

  const initMarlinProduct = (section) => {
    if (section.dataset.marlinProductReady === 'true') return;
    section.dataset.marlinProductReady = 'true';

    const mainImage = section.querySelector('#MarlinMainImage');
    const zoomLink = section.querySelector('[data-marlin-zoom]');
    const thumbs = section.querySelectorAll('[data-marlin-thumb]');
    const quantityInput = section.querySelector('[data-marlin-quantity-input]');
    const variantIdInput = section.querySelector('[data-marlin-variant-id]');
    const submit = section.querySelector('[data-marlin-submit]');
    const submitText = section.querySelector('[data-marlin-submit-text]');
    const price = section.querySelector('[data-marlin-price]');
    const variantsScript = section.querySelector('[data-marlin-variants-json]');
    const currency = section.dataset.currencyCode || window.Shopify?.currency?.active || 'AUD';

    let variants = [];

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (_error) {
        variants = [];
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');

        if (mainImage && thumb.dataset.full) {
          mainImage.src = thumb.dataset.full;
          mainImage.removeAttribute('srcset');
          mainImage.alt = thumb.dataset.alt || '';
        }

        if (zoomLink && thumb.dataset.zoom) {
          zoomLink.href = thumb.dataset.zoom;
        }
      });
    });

    section.querySelector('[data-marlin-quantity-minus]')?.addEventListener('click', () => {
      const current = Number(quantityInput?.value || 1);
      quantityInput.value = Math.max(1, current - 1);
    });

    section.querySelector('[data-marlin-quantity-plus]')?.addEventListener('click', () => {
      const current = Number(quantityInput?.value || 1);
      quantityInput.value = current + 1;
    });

    const updateVariant = () => {
      if (!variants.length) return;

      const selectedOptions = Array.from(section.querySelectorAll('.marlin-product__radio:checked'))
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((input) => input.value);

      const selectedVariant = variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!selectedVariant) return;

      if (variantIdInput) {
        variantIdInput.value = selectedVariant.id;
      }

      if (price) {
        price.textContent = formatMoney(selectedVariant.price, currency);
      }

      if (submit && submitText) {
        submit.disabled = !selectedVariant.available;
        submitText.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      }

      if (selectedVariant.featured_media && mainImage) {
        const matchingThumb = Array.from(thumbs).find((thumb) => {
          return thumb.dataset.mediaId === String(selectedVariant.featured_media.id);
        });

        matchingThumb?.click();
      }
    };

    section.querySelectorAll('.marlin-product__radio').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-marlin-product]').forEach(initMarlinProduct);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
